import { InputItem } from '@/models/inputItem'
import { ApiResponseGrade } from '@/models/apiResponses/grades'
import { Subjects } from '@/const/Subjects'
import { ApiResponseStudyContentYear } from '@/models/apiResponses/studyContents'
import { ApiResponseOriginalCurriculumMonth } from '@/models/apiResponses/originalCurriculums'

export class StudySearchUtils {
  /**
   * プレースホルダーのInputItem型を生成する
   * @param label ラベル
   * @returns プレースホルダー用InputItem
   */
  public static buildPlaceholder(label: string): InputItem {
    return this.buildInputItem('', label)
  }

  /**
   * 学年のプルダウン情報を生成する
   * @param placeholder プレースホルダー
   * @param apiResponse API取得情報
   * @returns 学年のプルダウン用InputItem
   */
  public static buildGradeInputItems(placeholder: InputItem, apiResponse?: ApiResponseGrade[] | null): InputItem[] {
    const options = [placeholder]
    if (!apiResponse) return options

    return options.concat(apiResponse.map((res) => this.buildInputItem(String(res.id), res.name)))
  }

  /**
   * 教科のプルダウン情報を生成する
   * TODO: constの設定値から生成しているが、APIレスポンス値を使用する必要があるならばapiResponse引数と変換処理
   */
  public static buildSubjectInputItems(placeholder: InputItem): InputItem[] {
    const options = [placeholder]

    return options.concat(
      Subjects.LIST.map((val) => {
        return this.buildInputItem(val.code, val.name)
      })
    )
  }

  /**
   * 実施年度のプルダウンを生成する
   * @param placeholder プレースホルダー
   * @param apiResponse API取得情報
   * @returns 実施年度のプルダウン用InputItem
   */
  public static buildYearInputItems(
    placeholder: InputItem,
    apiResponse?: ApiResponseStudyContentYear[] | null
  ): InputItem[] {
    const options = [placeholder]
    if (!apiResponse) return options

    return options.concat(
      apiResponse.map((response) => this.buildInputItem(String(response.value), `${response.label}年`))
    )
  }

  /**
   * 実施月のプルダウンを生成する
   * @param placeholder プレースホルダー
   * @param apiResponse API取得情報
   * @returns 実施月のプルダウン用InputItem
   */
  public static buildMonthInputItems(
    placeholder: InputItem,
    apiResponse?: ApiResponseOriginalCurriculumMonth[] | null
  ): InputItem[] {
    const options = [placeholder]
    if (!apiResponse) return options

    return options.concat(apiResponse.map((response) => this.buildInputItem(String(response.value), response.label)))
  }

  /**
   * フォーム入力で使用するInputItem型を生成する
   * @param value 値
   * @param label ラベル
   * @returns InputItem
   */
  private static buildInputItem(value: string, label: string): InputItem {
    return { value: value, label: label }
  }
}
